import React, { useState, useEffect } from 'react';
import dolibarrApi from '../services/dolibarrApi';

const OrderStatus = () => {
  const [order, setOrder] = useState(null);
  const [error, setError] = useState(null);

  // Check URL parameters on component mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get('ref');
    if (ref) {
      fetchOrderStatus(ref);
    }
  }, []);

  const fetchOrderStatus = async (ref) => {
    if (!ref.trim()) return;

    setError(null);

    try {
      // First try to get as invoice (new orders)
      try {
        const invoiceData = await dolibarrApi.getInvoice(ref);
        setOrder(invoiceData);
        return;
      } catch (invoiceError) {
        // If not found as invoice, try as proposal (legacy orders)
        const proposalData = await dolibarrApi.getProposalByRef(ref);
        setOrder(proposalData);
      }
    } catch (err) {
      console.error('Error fetching order:', err);
      setError('Order not found. Please check your order reference.');
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case '0': return 'Draft';
      case '1': return 'Validated';
      case '2': return 'Accepted';
      case '3': return 'Refused';
      case '4': return 'Billed';
      default: return 'Unknown';
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case '0': return 'status-draft';
      case '1': return 'status-validated';
      case '2': return 'status-accepted';
      case '3': return 'status-refused';
      case '4': return 'status-billed';
      default: return 'status-unknown';
    }
  };

  return (
    <section className="order-status">
      <h2>ORDER STATUS</h2>

      {error && <div className="error-message">{error}</div>}

      {order && (
        <div className="order-details">
          <h3>Order Details</h3>
          <div className="order-info">
            <div className="info-row">
              <span className="label">Order Reference:</span>
              <span className="value">{order.ref}</span>
            </div>
            <div className="info-row">
              <span className="label">Status:</span>
              <span className={`status ${getStatusClass(order.fk_statut)}`}>
                {getStatusText(order.fk_statut)}
              </span>
            </div>
            <div className="info-row">
              <span className="label">Date:</span>
              <span className="value">
                {new Date(order.date_creation * 1000).toLocaleDateString()}
              </span>
            </div>
            <div className="info-row">
              <span className="label">Total:</span>
              <span className="value">£{parseFloat(order.total_ttc).toFixed(2)}</span>
            </div>
            {order.date_livraison && (
              <div className="info-row">
                <span className="label">Delivery Date:</span>
                <span className="value">
                  {new Date(order.date_livraison * 1000).toLocaleDateString()}
                </span>
              </div>
            )}
          </div>

          {order.lines && order.lines.length > 0 && (
            <div className="order-lines">
              <h4>Order Items</h4>
              {order.lines.map((line, index) => (
                <div key={index} className="order-line">
                  <span className="line-desc">{line.description || line.libelle}</span>
                  <span className="line-qty">Qty: {line.qty}</span>
                  <span className="line-price">£{parseFloat(line.total_ttc).toFixed(2)}</span>
                </div>
              ))}
            </div>
          )}

          <div className="order-notes">
            {order.note_public && (
              <div className="note">
                <strong>Public Note:</strong> {order.note_public}
              </div>
            )}
            {order.note_private && (
              <div className="note">
                <strong>Private Note:</strong> {order.note_private}
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default OrderStatus;
